// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__MIgqe","content":"styles_content__1Mp0y","selectAll":"styles_selectAll__2lSuG"};